import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./BlogPop.module.scss";
import { Controller, useForm } from "react-hook-form";
import {
  useAddBlogMutation,
  useUpdateBlogMutation,
} from "../../../store/services/blogServices";
import toast from "react-hot-toast";
//import CKEditorField from "../../ckEditor/CKEditorField";
import CKEditorNew from "../../newCkEditor/ckEditor";
import Dropzone from "../../Dropzone/Dropzone";

const BlogPop = ({ title, modalOpen, setModalOpen, edit }) => {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // Validation mode set to 'onTouched'
    defaultValues: {
      title: edit?.title,
      status: edit?.status,
      description: edit?.description,
      blogImage: edit?.blogImage,
    },
  });

  const [addBlog, { isLoading: isAdding }] = useAddBlogMutation();
  const [updateBlog, { isLoading: isUpdating }] = useUpdateBlogMutation();

  // Submit handler
  const onSubmit = async (data) => {
    try {
      if (edit !== null) {
        // Update existing meal
        await updateBlog({
          blogId: edit._id,
          updatedData: data,
        });
      } else {
        await addBlog(data).unwrap(); // Call deleteBlog and handle success
      }
      setModalOpen(false);
      return toast.success(
        `Blog ${edit ? "updated" : "added"} successfully`
      );
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };
  return (
    <Modal
      show={modalOpen}
      className={`${styles.BlogPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
      size="lg"
      enforceFocus={false}
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg="12" md="12" className="my-2">
                  {/* Name Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Title
                    </label>
                    <input
                      placeholder="Enter title"
                      type="text"
                      name="title"
                      // {...register("title", {
                      //   required: "Please enter title",
                      // })}
                      {...register("title", {
                        required: "Please enter title",
                        validate: (value) => {
                          if (/^\s/.test(value)) {
                            return "Title cannot start with a space";
                          }
                          // if (/[^a-zA-Z0-9\s]/.test(value)) {
                          //   return "Title cannot include special characters or emojis";
                          // }
                          return true;
                        },
                      })}
                      className="form-control"
                    />

                    {errors.title && (
                      <span className="text-danger">
                        {errors.title.message}
                      </span>
                    )}
                  </div>
                </Col>
                <Col lg="12" md="12" className="my-2">
                  {/* Description Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Answer
                    </label>

                    <Controller
                      name="description"
                      control={control}
                      rules={{ required: "Please enter answer" }}
                      render={({ field }) => (
                        <CKEditorNew
                          field="description"
                          setFieldValue={setValue}
                          value={field.value}
                          error={errors}
                        />
                      )}
                    />
                   
                    {errors.description && (
                      <span className="text-danger">
                        {errors.description.message}
                      </span>
                    )}
                  </div>
                </Col>
                <Col lg="12" md="12" className="my-2">
                  {/* Description Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Blog image
                    </label>

                    <Controller
                      name="blogImage"
                      control={control}
                      rules={{ required: "Please enter blog image" }}
                      render={({ field }) => (
                        <Dropzone
                          field="blogImage"
                          setFieldValue={setValue}
                          value={field.value}
                          error={errors}
                        />
                      )}
                    />
                    {errors.blogImage && (
                      <span className="text-danger">
                        {errors.blogImage.message}
                      </span>
                    )}
                  </div>
                </Col>
                <Col lg="6" md="6" className="my-2">
                  {/* Status Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Status
                    </label>
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                      <li className="d-flex align-items-center">
                        <input
                          type="radio"
                          value="active"
                          {...register("status", {
                            required: "One radio button should appear selected",
                          })}
                          className="form-check"
                        />
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Active
                        </label>
                      </li>
                      <li className="d-flex align-items-center">
                        <input
                          type="radio"
                          value="inactive"
                          {...register("status", {
                            required: "One radio button should appear selected",
                          })}
                          className="form-check"
                        />
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Inactive
                        </label>
                      </li>
                    </ul>
                    {errors.status && (
                      <span className="text-danger">
                        {errors.status.message}
                      </span>
                    )}
                  </div>
                </Col>
              </Row>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BlogPop;
